// src/utils/contactFieldIcons.js
//
// Shared leading-icon glyphs for the four contact field types — phone, email, website,
// address. A site-wide convention for "what marks this kind of contact line," not a
// Directory-local choice: any surface rendering these fields should import this rather
// than hardcoding its own copy or picking a different mark for the same field type.
//
// Emoji, matching the icon source already established on Directory entry rows — not the
// app's Lucide icon system (StandardButton.jsx's iconRegistry, tokens.icon.strokeWidth).
// These glyphs were never routed through StandardButton and this file doesn't start that;
// it only centralises what was already duplicated between PresencePanel and DirectoryNav.
export const CONTACT_GLYPH = {
  phone: '\u{1F4DE}',    // 📞
  email: '✉️', // ✉️
  website: '\u{1F310}',  // 🌐
  address: '\u{1F4CD}'   // 📍
};
